import { classNames } from 'shared/lib/classNames/classNames'
import cls from '../InstallWidget.module.scss'
import { Button } from 'shared/ui/Button'
import logo from 'shared/assets/MineCards-Logo-Rounded.svg'
import { Cross } from 'shared/ui/Cross'
import { IconBadge, IconBadgeTone, TimeIcon } from 'shared/ui/Icon'

export const IosInstall = (props) => {
    const { onCloseInstall, cross } = props
    return (
        <div className={classNames(cls.InstallWidget, {}, [])}>
            {cross ? <Cross onClose={onCloseInstall} /> : null}
            <div className={cls.ImageContainer}>
                <img className={cls.Image} alt="MineCards" src={logo} />
                <IconBadge className={cls.Icon} tone={IconBadgeTone.GRAY}>
                    <TimeIcon />
                </IconBadge>
            </div>
            <div className={cls.Text}>
                Приложение для твоего телефона в разработке
            </div>
            <Button
                onClick={onCloseInstall}
                className={cls.Button}
                text={'Продолжить пользоваться в браузере'}
            />
        </div>
    )
}
